export default __webpack_public_path__ + "static/media/bkmexpress-logo.06480a07.png";